import React from "react";

const ValidationFailedModal = ({ onClick }) => {
  return (
    <div className="fixed top-8 left-1/2 transform -translate-x-1/2 w-full h-full flex justify-center items-center px-4">
      <div className="bg-white p-6 text-center w-full max-w-lg md:max-w-xl lg:max-w-2xl h-auto shadow-lg flex flex-col items-center justify-center rounded-lg">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-[#FFE0E0] rounded-full flex items-center justify-center">
          <img src="/red-cross.png" alt="Red Cross" className="w-10 h-10 md:w-12 md:h-12" />
        </div>

        <p className="text-[#000] text-lg md:text-xl mt-4 font-semibold">
          File Not Validated
        </p>
        <p className="text-[#000] text-sm md:text-base mt-2">
          Sorry, we could not validate your file!
        </p>
        <button
          className="bg-[#005C53] text-white w-full max-w-md h-[45px] md:h-[51px] rounded-lg mt-5"
          onClick={onClick}
        >
          Check Errors
        </button>
      </div>
    </div>
  );
};

export default ValidationFailedModal;
